export function getNearbyAirportCodes(airportItem) {
  return airportItem.nearby?.map(nearbyItem => nearbyItem.code) ?? [];
}
export function isAllAirportNearbyChecked(airportItem, isChecked) {
  return getNearbyAirportCodes(airportItem).every(isChecked);
}